import { useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import { useGetAppointment } from "./useGetAppointment";

interface UseSelectAppointmentProps {
  clientId: number;
  preOrderId: number;
  zipcode: string;
}

export const useSelectAppointment = ({
  clientId,
  preOrderId,
  zipcode,
}: UseSelectAppointmentProps) => {
  const currentDate = new Date();
  const monthFormatted = String(currentDate.getMonth() + 1).padStart(2, "0");
  const initialDate = `${currentDate.getFullYear()}-${monthFormatted}`;

  const [dateRequest, setDateRequest] = useState(initialDate);

  const [appointmentTypeID, setAppointmentTypeID] = useState<null | number>(
    null
  );

  const [appointment, setAppointment] = useState({
    query_date: "",
    query_hour: "",
  });

  const client = useQueryClient();

  const { availableDates, availableHours } = useGetAppointment({
    appointmentId: null,
    zipcode,
    dateRequest,
    query_date: appointment.query_date,
    clientId,
    preOrderId,
  });

  const setDefaultAppointment = () => {
    setAppointment({ query_date: "", query_hour: "" });
    client.removeQueries({ queryKey: ["available-dates"] });
    client.removeQueries({ queryKey: ["available-hours"] });
  };

  const handleSelectDate = (query: { option: string }) => {
    setAppointment({ query_date: query.option, query_hour: "" });
  };

  const handleSelectHour = async (query: { option: string }) => {
    setAppointment((prev) => ({ ...prev, query_hour: query.option }));
  };

  const resetData = () => {
    setAppointment({
      query_date: "",
      query_hour: "",
    });
    client.removeQueries({ queryKey: ["available-dates"] });
    client.removeQueries({ queryKey: ["available-hours"] });
  };

  const { data } = availableDates ?? {};

  const [pos] = data ?? [];

  const [year, month, day] = pos?.query.split("-") ?? "";
  const currentMonth = new Date(year, month - 1, day);

  const monthSelected = currentMonth.toLocaleDateString("pt-BR", {
    month: "long",
  });

  const capitilizedMonth =
    monthSelected.charAt(0).toUpperCase() + monthSelected.slice(1);

  useEffect(() => {
    return () => resetData();
  }, []);

  return {
    dateRequest,
    availableDates,
    setDateRequest,
    capitilizedMonth,
    handleSelectDate,
    availableHours,
    appointment,
    handleSelectHour,
    setDefaultAppointment,
    appointmentTypeID,
    setAppointmentTypeID,
  };
};
